import {createReducer} from '@reduxjs/toolkit'
import {AnyAction} from 'redux'
import {FETCH_CURRENT_MEMBER_OLD, fetchCurrentMember} from '../actions/members'
import {CurrentMemberDetails} from '../types/state'

const defaultState: CurrentMemberDetails = {
  id: undefined,
  firstName: undefined,
  lastName: undefined,
  email: undefined,
}

export const currentMemberDetails = createReducer(defaultState, builder => {
  builder
    .addCase(FETCH_CURRENT_MEMBER_OLD.SUCCESS, (state, action: AnyAction) => {
      const member = action.payload
      return {
        ...state,
        id: member?.id,
        email: member?.loginEmail,
        firstName: member?.firstName,
        lastName: member?.lastName,
      }
    })
    .addCase(fetchCurrentMember.fulfilled, (state, action) => {
      const member = action.payload

      state.id = member?.id
      state.email = member?.loginEmail
      state.firstName = member?.firstName
      state.lastName = member?.lastName
    })
})
